/**
 * 字典查询
 */

export default {
    url: hostSystemFun().url,
    host: hostSystemFun().host,
    ws: hostSystemFun().ws,
    imgSrc: 'http://css.hntfkj.com:11603/group1/M00/94/75/rBAABGU4owKAbuAOAACWCrHelnA517.png', // 停车缺图图片
    downLoadUrl: 'http://css.hntfkj.com:11603/', // 图片前缀
    mapKey: 'ee61e567af9460f7f9734ac3ebc4f64d', // 高德地图key
    securityJsCode: '3966ec6d56595a3d6ff3ddc43a9259f8', // 高德地图安全密钥
}

// 根据域名识别环境
function hostSystemFun() {
    let hostObj = {
        url: 'https://tfhcx.hntfkj.com', // uat环境
        host: '/expand-uat', // 服务名
    };
    let hostObj0 = {
        url: 'http://172.16.0.2:9918', // 刘达文本地环境
        host: '/cs-expand-uat', // 服务名
    };
    let hostObj1 = {
        url: 'https://tfhcxaliyun.hntfkj.com', // 正式环境
        host: '/cs-expand', // 服务名
    };


    if (process.env.NODE_ENV === "development") {
        const rawConfig = require('../../../config/index.js'); // 注意路径
        const hosts = rawConfig.dev.proxyTable['/api'].target;
        console.log('代理地址：', hosts);
        // 开发环境
        if (hosts.indexOf('tfhcx.hntfkj.com') >= 0) {
            return hostObj;
        } else if (hosts.indexOf('http://172.16.0.2') >= 0) {
            return hostObj0;
        } else if (hosts.indexOf('tfhcxaliyun.hntfkj.com') >= 0) {
            return hostObj1;
        } else {
            return {};
        }
    } else {
        const host = window.location.href;
        console.log('请求域名：', host);
        if (host.indexOf('tfhcx.hntfkj.com') >= 0) {
            return hostObj;
        } else if (host.indexOf('tfhcxaliyun.hntfkj.com') >= 0) {
            return hostObj1;
        } else {
            return {};
        }
    }

}



// WEBPACK FOOTER //
// ./src/config/apiConfig/hostInfo.js